import { Mail, Phone, MapPin, Instagram, Linkedin } from "lucide-react";
import useReveal from "../lib/useReveal";

export const Footer = () => {
  const ref = useReveal();
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-[#1E3A2B] text-[#FCFBF7] overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12 py-16 sm:py-24 lg:py-32" ref={ref}>
        <div className="reveal max-w-4xl">
          <span className="uppercase text-[10px] sm:text-xs tracking-[0.28em] text-[#C25E3E] font-semibold">
            Begin
          </span>
          <h2 className="font-display text-4xl sm:text-6xl lg:text-[6.5rem] tracking-tight leading-[0.95] mt-5 sm:mt-6">
            Your first step
            <br />
            is a <span className="italic text-[#C25E3E]">conversation.</span>
          </h2>
          <p className="mt-6 sm:mt-8 text-base sm:text-lg text-[#FCFBF7]/70 max-w-2xl">
            Reach us directly — no forms, no funnels. Tell us what&rsquo;s
            going on and we&rsquo;ll pair you with the right specialist within
            24 hours.
          </p>
        </div>

        <div className="reveal mt-10 sm:mt-16 grid md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl">
          <ContactRow
            icon={Mail}
            label="Email"
            value="care@aasahealthscience.com"
            href="mailto:care@aasahealthscience.com"
            testid="contact-email"
          />
          <ContactRow
            icon={Phone}
            label="Phone"
            value="+91 84351 15896"
            href="tel:+918435115896"
            testid="contact-phone"
          />
          <ContactRow
            icon={MapPin}
            label="Studio"
            value="Indore, India"
            testid="contact-address"
          />
        </div>

        <div className="reveal mt-20 pt-10 border-t border-[#FCFBF7]/15 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <div className="font-display text-3xl">
              Aasa{" "}
              <span className="italic text-[#C25E3E]">
                Healthscience &amp; Nutrition
              </span>
            </div>
            <p className="mt-2 text-sm text-[#FCFBF7]/55 max-w-md">
              Holistic, multidisciplinary care for metabolic and hormonal
              health.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <SocialButton
              icon={Instagram}
              label="Instagram"
              href="https://www.instagram.com/aasa.healthscience.nutrition?igsh=MWU1MHR2YnVwYTNibQ=="
              testid="social-instagram"
            />
            <SocialButton
              icon={Linkedin}
              label="LinkedIn"
              href="https://linkedin.com"
              testid="social-linkedin"
            />
          </div>
        </div>

        <div className="mt-12 text-xs text-[#FCFBF7]/40 tracking-wide">
          © {new Date().getFullYear()} Aasa Healthscience &amp; Nutrition. All
          rights reserved.
        </div>
      </div>
    </footer>
  );
};

const ContactRow = ({ icon: Icon, label, value, href, testid }) => {
  const content = (
    <div className="group flex items-start gap-4 py-2">
      <span className="inline-flex w-11 h-11 items-center justify-center rounded-full border border-[#FCFBF7]/20 group-hover:bg-[#C25E3E] group-hover:border-[#C25E3E] transition-colors">
        <Icon className="w-4 h-4" />
      </span>
      <div>
        <div className="text-xs uppercase tracking-[0.22em] text-[#FCFBF7]/55">
          {label}
        </div>
        <div className="font-display text-2xl mt-1">{value}</div>
      </div>
    </div>
  );
  return href ? (
    <a data-testid={testid} href={href} className="block">
      {content}
    </a>
  ) : (
    <div data-testid={testid}>{content}</div>
  );
};

const SocialButton = ({ icon: Icon, label, href, testid }) => (
  <a
    data-testid={testid}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className="inline-flex w-11 h-11 items-center justify-center rounded-full border border-[#FCFBF7]/25 hover:bg-[#C25E3E] hover:border-[#C25E3E] transition-colors"
  >
    <Icon className="w-4 h-4" />
  </a>
);

export default Footer;
